import { Perspective } from 'queries/utils/sortPerspectives';
import API from './API';
import { handleError, handleResponse } from './util';

export const GetPerspectivesForNode = async (nodeId: string): Promise<{ perspectives: Perspective[] }> => {
    return API.get(`/objects/${nodeId}/perspectives`).then(handleResponse).catch(handleError);
};
